// Path: ./src/app/components/CreateTagModal/styled.ts
import styled from "styled-components";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";

export const InheritTextInputField = styled(TextInputField)`
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px;
`;

export const Card = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: start;
  flex-wrap: wrap;
  max-width: 600px;
  padding: 15px 16px 10px 16px;
  margin-top: 20px;
`;
export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 293px;
  margin: auto;
`;
export const ImageCard = styled.img`
  height: 293px;
  width: 293px;
  border-radius: 10px;
  box-shadow: 0px 5px 5px 0px #8888886b;
  object-fit: contain;
  object-position: center;
`;
export const ImageSubTitle = styled.div`
  padding: 4px;
  margin-top: 8px;
  font-size: 12px;
  text-transform: CAPITALIZE;
  width: 293px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  background: #fff;
`;
export const Button = styled.div`
  padding: 6px 14px 6px 14px;
  border: 2px solid #ff8038;
  border-radius: 10px;
  transition: all 0.3s;
  :hover {
    background-color: #ff8038;
    color: white;
  }
  cursor: pointer;
`;

interface LocalButtonProps {
  for?: string;
}
export const LocalButton = styled.label<LocalButtonProps>`
  padding: 6px 14px 6px 14px;
  border: 2px solid #ff8038;
  border-radius: 10px;
  transition: all 0.3s;
  :hover {
    background-color: #ff8038;
    color: white;
  }
  cursor: pointer;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 4px;
`;
export const SyncUpdateHeader = styled.div`
  width: 100%;
  background-color: #ff8038;
  text-align: center;
  color: white;
  margin-top: 10px;
  font-size: 12px;
`;
export const CheckBoxWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  margin-top: 10px;
`;

export const RightSideWrapper = styled.div`
  padding-left: 16px;
  margin: auto;
  @media (max-width: 943px) {
    margin-top: 30px;
  }
`;
export const RightSideTitle = styled.div``;
export const SalesSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
`;
export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  @media (max-width: 649px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const UnitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 649px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const BottomSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 649px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const BottomLeftWrapper = styled.div``;

export const BottomRightWrapper = styled.div``;

export const DotDotDivider = styled.div`
  border: none;
  border-top: 1px dotted grey;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const SubmitButton = styled.div`
  width: 8rem;
  background-color: #ff8038;
  height: 3rem;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 11px;
  cursor: pointer;
  @media (max-width: 649px) {
    height: 50px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 15px;
  }
`;

export const RegularPrice = styled.div``;
export const RegularPriceTitle = styled.div``;

export const StoreTagTItle = styled.h3``;

export const IconUpload = styled.span`
  width: 100%;
  min-height: 96px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  color: #757575;
  background-color: #ffffff;
  border: 2px dashed #d8d8d8;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8px;
  transition: transform 0.3s;
  cursor: pointer;
  input[type="file"] {
    position: absolute;
    height: 100%;
    width: 100%;
    opacity: 0;
    top: 0;
    left: 0;
  }
`;

export const IconInput = styled.input``;

export const ImageUploadSection = styled.div`
  width: 100%;
  max-width: 420px;
  border: 1px solid #ececec;
  border-radius: 12px;
  padding: 12px;
  background: #fafafa;
`;

export const ImagePreviewCard = styled.div`
  width: 100%;
  height: 140px;
  border-radius: 10px;
  border: 1px solid #e2e2e2;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  margin-bottom: 10px;
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const ImagePreviewPlaceholder = styled.div`
  color: #9a9a9a;
  font-size: 13px;
`;

export const PreferenceOptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  max-width: 420px;
  padding: 4px 8px 4px 4px;
  border: 1px solid #dedede;
  border-radius: 8px;
  background: #fafafa;
`;
